<template>
  <div>
    <slot name="header" />
    <apexchart
      id="donut-chart"
      class="w-100"
      :height="height"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ApexChartsLocale } from '@/data/models/ApexchartsLocale'
import i18n from '@/plugins/i18n'

export default {
  name: 'DonutChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: () => ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    },
    height: {
      type: String,
      default: '400'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: null
    },
    xaxis: {
      type: Object,
      default: () => ({
        labels: {
          show: true
        }
      })
    },
    yaxis: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Array,
      default: () => []
    },
    donutSize: {
      type: String,
      default: '70%'
    },
    showDonutLabels: {
      type: Boolean,
      default: true
    },
    centerText: {
      type: String,
      default: null
    },
    centerValue: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    colorss() {
      return this.$vuetify.theme.secondary
    },
    chartOptions() {
      return {
        colors: this.colors,
        chart: {
          height: this.height,
          toolbar: {
            show: false
          },
          type: 'donut',
          locales: ApexChartsLocale,
          defaultLocale: i18n.locale
        },
        labels: this.labels,
        legend: {
          show: this.showLegend
        },
        plotOptions: {
          pie: {
            donut: {
              size: this.donutSize,
              labels: {
                show: this.showDonutLabels,
                name: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10,
                  formatter: function (val) {
                    return val
                  }
                },
                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: undefined,
                  offsetY: 16,
                  formatter: (val) => {
                    return this.centerValue || val
                  }
                },
                total: {
                  show: this.centerValue,
                  showAlways: false,
                  label: this.centerText || '',
                  fontSize: '14px',
                  fontWeight: 400,
                  formatter: (w) => {
                    if (this.centerValue) {
                      return this.centerValue
                    }
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: !this.hideLabels
        },
        tooltip: {
          y: {
            formatter: (value) => {
              return value + ' ' + this.$tc('repeat_settings.day', value)
            },
            title: {
              formatter: (seriesName) => seriesName
            }
          }
        },
        xaxis: this.xaxis,
        yaxis: this.yaxis,
        annotations: {
        }
      }
    }
  }
}
</script>
